import axios from 'axios'

export const API = axios.create({
  baseURL: 'https://api.agrovar.bg/api/',
  withCredentials: true,
})
